export default __webpack_public_path__ + "static/media/a1.eac1ff52.png";